var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input"},[_vm._t("default",function(){return [_c('b-input',_vm._b({attrs:{"value":_vm.value,"password-reveal":_vm.isPassword},on:{"input":_vm.update}},'b-input',_vm.$attrs,false))]},{"value":_vm.value,"update":_vm.update})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }